import React from 'react';
import { Image as SemanticImage } from 'semantic-ui-react';

import { Formatters } from 'Common/Helpers';
import { FALLBACK_IMAGE } from 'Common/Constants';
import { hasDataUri, isBase64 } from 'Common/FormHelper';

/**
 * Image wrapper that handles base64 and falls back to a placeholder image
 */
const Base64Image = ({ src, type, ...rest }) => {
  const imageSrc = Boolean(src)
    ? isBase64(src, { allowMime: true })
      ? hasDataUri(src)
        ? src
        : Formatters.prependBase64(src, type)
      : src
    : FALLBACK_IMAGE;
  return <SemanticImage src={imageSrc} {...rest} />;
};

export { Base64Image };



// WEBPACK FOOTER //
// ./src/common/Components/Base64Image/Base64Image.js